import * as React from "react";
// import { pure } from 'recompose'
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { item /*rediRectToo*/ } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <section className="arrayContent camera-liste-">
      {Utils.simpleAuthorizationIsAllowed(User, [
        Enums.AuthorizationRightsEnums.CAMERADETAILS,
      ]) && (
        <Link
          to={`${Paths.PathsNamesEnums.CAMERASETTINGID}${item.id}`}
          style={{ cursor: "pointer", width: "100%" }}
        >
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p>{item && item.code}</p>
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "10%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p>{item && item.location}</p>
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "30%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                {item.connected && item.snapshot === "" && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("impossible de charge l image")}
                  </p>
                )}
                {item.connected && item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {i18next.t("pas de signal video")}
                  </p>
                )}
                {item.connected && item.move && !item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("bouge de camera")}
                  </p>
                )}
                {item.connected && !item.move && !item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("signal video ok")}
                  </p>
                )}
                {!item.connected && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("pas de flux video")}
                  </p>
                )}
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                {item && item.section && (
                  <p
                    style={{
                      width: "180px",
                      color: item.section.colorRgbString,
                    }}
                  >
                    {item.section.name}
                  </p>
                )}
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p style={{ padding: "9px 20px" }}>---</p>
              </div>
            </div>
          </span>
        </Link>
      )}
      {!Utils.simpleAuthorizationIsAllowed(User, [
        Enums.AuthorizationRightsEnums.CAMERADETAILS,
      ]) && (
        <a style={{ width: "100% " }}>
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p>{item && item.code}</p>
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "10%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p>{item && item.location}</p>
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "30%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                {item.connected && item.snapshot === "" && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("impossible de charge l image")}
                  </p>
                )}
                {item.connected && item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {i18next.t("pas de signal video")}
                  </p>
                )}
                {item.connected && item.move && !item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("bouge de camera")}
                  </p>
                )}
                {item.connected && !item.move && !item.noSignal && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("signal video ok")}
                  </p>
                )}
                {!item.connected && (
                  <p style={{ width: "280px" }}>
                    {" "}
                    {i18next.t("pas de flux video")}
                  </p>
                )}
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                {item && item.section && (
                  <p
                    style={{
                      width: "180px",
                      color: item.section.colorRgbString,
                    }}
                  >
                    {item.section.name}
                  </p>
                )}
              </div>
            </div>
          </span>
          <span className="arraysContentSpanAuto" style={{ width: "20%" }}>
            <div className="arraysContentContenair">
              <div className="arrayContentInfos">
                <p style={{ padding: "9px 20px" }}>---</p>
              </div>
            </div>
          </span>
        </a>
      )}
    </section>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  rediRectToo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/camera-list/component.tsx